import { getYardVendors, getListHandlingCompany } from "@/repositories/kintoneConvertor";

export default {
  async fetchYardVendorFromJC() {
    return await getYardVendors();
  },
  async handlingCompanyFromJC() {
    return await getListHandlingCompany();
  },

};
